import React from 'react';
import CCMRSSyle from '../style';
import bannerImage from '../../../images/CCMRS/banner.png';
import CourseDescriptionV2Image from '../../../images/CCMRS/CCMRCourseDescriptionV201.png';
import CourseLandingScreen from '../../../components/courseLandingScreen/index';
import CourseDescription from '../../../components/courseDescription/index';
import WarningBlock from '../../../components/warningBlock';
import CourseDescriptionV2 from '../../../components/courseDescriptionV2';
import CourseSchedule from '../../../components/courseSchedule';
import NextBackNav from '../../../components/nextBackNav';
import InfoBlock from '../../../components/infoBlock';

export default function Page02({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = CCMRSSyle();
	return (
		<div style={style.outerStyle()}>
			<CourseDescription
				addonStyle={style.courseDescriptionStyle()}
				title='INSTRUCTIONS'
				texts={[
					'1. Each ROUND will have 1(ALPHA) & 2-4(BETA’S) exercises.',
					'2. After each exercise is done efficiently! When heading to the next exercise, it is done with a slight jog; this causes your body to keep warm and blood flowing. It also increases your cardiovascular system, which is beneficial.',
					'3. Full intensity when each round begins, non-stop movement till the round ends.',
					'4. 1-2 Minute Breaks after each round is finished.',
					'5. The 1st (ALPHA & BETA) exercise will always be required to have 6 Rounds; after that, all other (ALPHA & BETA) exercises rounds will all be conducted 3-4 Rounds.',
					'6. Every 2 rounds completed add weight to (ALPHA) exercises.',
					'7. FOCUS!!',
				]}
			/>
			<CourseSchedule
				mt={true}
				days={[
					{
						name: 'Sunday',
						action: 'Rest',
					},
					{
						name: 'Monday',
						action: 'Back C.C.M.R’s',
					},
					{
						name: 'Tuesday',
						action: 'Stretches/Light Cardio',
					},
					{
						name: 'Wednesday',
						action: 'Chest C.C.M.R’s',
					},
					{
						name: 'Thursday',
						action: 'Stretches/Light Cardio',
					},
					{
						name: 'Friday',
						action: 'Rest',
					},
					{
						name: 'Saturday',
						action: 'Leg C.C.M.R’s',
					},
				]}
			/>
			<InfoBlock mt={true} texts={['“Client may pick what day seems necessary to start of the week.”']} />
			<InfoBlock
				mt={true}
				texts={[
					'“The client may also rearrange the order of the Exercises, Stretches, Cardio, and rest but it is not advised.”',
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
